import { render, staticRenderFns } from "./TeamsIntegration.vue?vue&type=template&id=7436fb11&"
import script from "./TeamsIntegration.vue?vue&type=script&lang=ts&"
export * from "./TeamsIntegration.vue?vue&type=script&lang=ts&"
import style0 from "./TeamsIntegration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports